import React from 'react';
import styles from './styles.module.scss';
import Button from '../../Button_V2';
import { getPreferredWalletProviderName } from '@wolffun/shared/src/utils/session';
import { WalletProvider } from '../../../types';
import Modal from '@wolffun/shared/src/Components/Modal';

const ConfirmOpenModal = ({
  onClick
}) => {
  const preferredWallet = React.useMemo(() => {
    return getPreferredWalletProviderName();
  }, []);
  React.useEffect(() => {
    if (preferredWallet !== WalletProvider.WALLET_CONNECT) {
      onClick();
    }
  }, [preferredWallet]);
  return preferredWallet === WalletProvider.WALLET_CONNECT ? /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.iconContainer
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, "Open Connect Wallet"), /*#__PURE__*/React.createElement(Button, {
    className: styles.buttonGroup,
    title: "Open",
    onClick: onClick
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null);
};

export default ConfirmOpenModal;